import React, { useState } from 'react';
import { Trash2, AlertTriangle } from 'lucide-react';

const PurgeRecords = () => {
  const [daysOld, setDaysOld] = useState(30);
  const [confirming, setConfirming] = useState(false);

  return (
    <div style={{ padding: '2rem', maxWidth: '600px' }}>
      <h1><Trash2 size={24} style={{ display: 'inline', marginRight: '1rem', color: '#ef4444' }} />Purge Records</h1>

      <div style={{ background: '#fee2e2', border: '1px solid #fca5a5', padding: '1rem', borderRadius: '8px', marginTop: '2rem' }}>
        <div style={{ display: 'flex', gap: '1rem', color: '#991b1b' }}>
          <AlertTriangle size={20} />
          <div>
            <div style={{ fontWeight: '600', marginBottom: '0.5rem' }}>Danger Zone</div>
            <div>This action will permanently delete all records older than the specified number of days.</div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: '2rem' }}>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>
          Delete records older than (days):
        </label>
        <input
          type="number"
          value={daysOld}
          onChange={(e) => setDaysOld(parseInt(e.target.value))}
          min="7"
          max="365"
          style={{ width: '100%', padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: '6px' }}
        />
      </div>

      <div style={{ marginTop: '2rem' }}>
        {!confirming ? (
          <button
            onClick={() => setConfirming(true)}
            style={{
              background: '#ef4444',
              color: 'white',
              padding: '0.75rem 1.5rem',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            Purge Records
          </button>
        ) : (
          <div>
            <p style={{ color: '#991b1b', marginBottom: '1rem' }}>
              ⚠️ Are you sure? This cannot be undone!
            </p>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <button
                onClick={() => {
                  alert(`Purging records older than ${daysOld} days...`);
                  setConfirming(false);
                }}
                style={{
                  background: '#ef4444',
                  color: 'white',
                  padding: '0.75rem 1.5rem',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontWeight: '600'
                }}
              >
                Confirm Purge
              </button>
              <button
                onClick={() => setConfirming(false)}
                style={{
                  background: '#e5e7eb',
                  color: '#1f2937',
                  padding: '0.75rem 1.5rem',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontWeight: '600'
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PurgeRecords;
